// import React, { useEffect, useState } from "react";

// import BtnLoader from "../../BtnLoader";
// import { Modal } from "react-bootstrap";
// import ReactTost from "../../ReactTost";
// import axios from "axios";
// import { useDropzone } from "react-dropzone";
// import { useTranslation } from "react-i18next";
// import { useParams } from "react-router-dom";

// const UserDocEdit = (props, { onDrop }) => {
//   const [loading, setLoading] = useState(false);
//   const [fileSize, setFileSize] = useState();
//   const [size, setSize] = useState(0);
//   let user = localStorage.getItem("id");

//   const [name, setName] = useState("");

//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState("");
//   const [type, setType] = useState("");

//   const [maxFileSize, setMaxFileSize] = useState(0);
//   const [maxFileCount] = useState(0);
//   const [, setTypeMsg] = useState("");
//   const [message, setMessage] = useState("");
//   const [showAlert, setShowAlert] = useState(false);
//   const [nameError, setNameError] = useState("");
//   const { t } = useTranslation();
//   const [fileError, setFileError] = useState("");
//   const { id } = useParams();
//   const API_URL = process.env.REACT_APP_API_URL;
//   const API_VERSION = process.env.REACT_APP_API_VERSION;

//   const handleFileSelection = (event) => {
//     const selectedFile = event.target.files[0];
//     setFile(selectedFile);
//     const allowedFileTypes = [
//       "application/pdf",
//       "application/msword",
//       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//       "text/plain",
//     ];

//     if (selectedFile && allowedFileTypes.includes(selectedFile.type)) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         // setFile(reader.result);
//       };
//       reader.readAsDataURL(selectedFile);
//       let _type = "doc";
//       if (selectedFile.type === "application/pdf") {
//         _type = "pdf";
//       }
//       setType(_type);
//       setFileName(selectedFile.name);

//       setSize((selectedFile.size / (1024 * 1024)).toFixed(2));
//     } else {
//       setFileError(
//         t("Please select a valid document file (PDF, DOC, DOCX, etc)")
//       );
//       event.target.value = null;
//     }
//   };
// function calculateRemainingSize(maxFileSize, fileSize) {
//   console.log(size)
//   console.log("maxFileSize", maxFileSize);
//   console.log("fileSize", fileSize)
//   let remainingSize =fileSize-maxFileSize;
//   console.log("remaining",remainingSize);
//   console.log("size", size);
//   if(size > remainingSize) {
//     return true;
//   }
//   else {
//     return false;
//   }
 
// }

//   const saveFile = async (e) => {
//     e.preventDefault();
//     let isValid = true;

//    let remainingSize = calculateRemainingSize(maxFileSize, fileSize);
//    console.log("res", remainingSize)
//     const bot = id;

//     if (!name) {
//       setNameError(t("Title is required."));
//       isValid = false;
//     } else {
//       setNameError("");
//     }

//     if (!file) {
//       setFileError(t("File is required."));
//       isValid = false;
//     } else if (remainingSize ===  true) {
      
//       setFileError(t("File size exceeds the total limit of plan"));
//       isValid = false;
//     } else {
//       setFileError("");
//     }

//     if (isValid) {
//       setLoading(true);
//       let formData = new FormData();
//       formData.append("file", file);
//       formData.append("name", name);
//       formData.append("fileName", fileName);
//       formData.append("user", user);
//       formData.append("type", type);
//       formData.append("bot", bot);
//       const config = {
//         headers: {
//           "content-type": "multipart/form-data",
//         },
//       };
    
//       try {
//         // const responseData = await ApiCall("user_doc", "POST", formData);
//         const responseData = await axios.post(
//           `${API_URL}/upload`,
//           formData,
//           config
//         );
//         if (responseData) {
//           setLoading(false);
//           setMessage(t("File uploaded successfully."));
//           setTypeMsg("Success");
//           setShowAlert(true);
//           props.doc();
//           setName("");
//           setFile(null);
//           props.onHide();
//           getAllDoc();
//         }
//       } catch (err) {
//         console.log(err);
//         setMessage(t("File not uploaded."));
//         setTypeMsg("Danger");
//         setShowAlert(true)
//         setLoading(false);
//       }
//     }
//   };

//   const handleNameChange = (event) => {
//     const newName = event.target.value;
//     setName(newName);
//     if (!newName) {
//       setNameError(t("Title is required."));
//     } else {
//       setNameError("");
//     }
//   };

//   function getAllDoc() {
//     setLoading(true);
//     axios
//       .get(`${API_URL}/${API_VERSION}/user_doc?id=${user}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((response) => {
//         setLoading(false);

//         const docList = response.data.usersDoc;
//         // Calculate total size in bytes
//         const totalSizeBytes = docList.reduce((acc, doc) => acc + doc.size, 0);
//         const totalSizeMegabytes = (totalSizeBytes / 1024).toFixed(2);
       
//         setMaxFileSize(totalSizeMegabytes);
    
//       })
//       .catch((error) => {
//         setLoading(false);
//         setType("Danger");
//         setMessage(t("Something went to wrong."));
//         setShowAlert(true);
//       });
//   }
//   useEffect(() => {
//     getAllDoc();
//   }, []);

//   useEffect(() => {
//     if (props.show) {
//       setNameError("");
//       setFileError("");
//     }
//   }, [props.show]);
// function checkPlan(){
//   axios
//   .get(`${API_URL}/${API_VERSION}/user/active-plan/${user}`, {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//     },
//   })
//   .then((response) => {
//     if (response.data) {
//       setFileSize(response.data.plan.storage);
//     }
//   })
//   .catch((error) => {
//     return false;
//   });
// }
//   useEffect(() => {
  
//     checkPlan();
//   }, [user, API_URL, API_VERSION]);

//   const { acceptedFiles } = useDropzone({
//     accept: {
//       "application/msword": [".doc"],
//       "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
//         [".docx"],
//       "application/pdf": [".pdf"],
//     },
//     maxSize: maxFileSize,
//     maxFiles: maxFileCount,
//     onDrop,
//     noClick: true,
//     noKeyboard: true,
//   });

//   return (
//     <>
//       <section className="client_main">
//         <ReactTost
//           onHide={() => {
//             setShowAlert(false);
//             setTypeMsg("");
//             setMessage("");
//           }}
//           alertClass={setTypeMsg}
//           alertMessage={message}
//           alertDo={showAlert}
//         />
//         <Modal
//           {...props}
//           size="md"
//           aria-labelledby="contained-modal-title-vcenter"
//           backdrop="static"
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title id="contained-modal-title-vcenter">
//               {t("Add Document")}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="form-group mb-3">
//               <label className="form-label">{t("Title")}</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="name"
//                 name="name"
//                 onChange={(event) => handleNameChange(event)}
//               />
//               <div className="text-danger">{nameError}</div>
//             </div>
//             <div className="form-group mb-3">
//               <label className="form-label" for="docFile">
//                 {t("Upload")}
//               </label>
//               <input
//                 type="file"
//                 className="form-control"
//                 id="docFile"
//                 accept=".pdf,.txt,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//                 onChange={handleFileSelection}
//               />
//               <div className="text-danger">{fileError}</div>
//             </div>
//             <div
//               className="alert alert-primary d-flex align-items-center"
//               role="alert"
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="icon icon-tabler icon-tabler-info-circle-filled"
//                 width="30"
//                 height="30"
//                 viewBox="0 0 24 24"
//                 stroke-width="1.5"
//                 stroke="#05204a"
//                 fill="none"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               >
//                 <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                 <path
//                   d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
//                   stroke-width="0"
//                   fill="currentColor"
//                 />
//               </svg>
//               <div className="ms-2">
//                 {t("Please upload the pdf, txt, doc, docx file only*")}
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               type="submit"
//               value="Save"
//               className="button px-md-4 py-md-3"
//               onClick={(e) => saveFile(e)}
//             >
//               {loading ? <BtnLoader /> : t("Save")}
//             </button>
//           </Modal.Footer>
//         </Modal>
//       </section>
//     </>
//   );
// };
// export default UserDocEdit;
import React, { useEffect, useState } from "react";
import BtnLoader from "../../BtnLoader";
import { Modal } from "react-bootstrap";
import ReactTost from "../../ReactTost";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const UserDocEdit = (props, { onDrop }) => {
  const [loading, setLoading] = useState(false);
  const [fileSize, setFileSize] = useState();
  const [size, setSize] = useState(0);
  let user = localStorage.getItem("id");

  const [name, setName] = useState("");

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [type, setType] = useState("");

  const [maxFileSize, setMaxFileSize] = useState(0);
  const [maxFileCount] = useState(0);
  const [, setTypeMsg] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [nameError, setNameError] = useState("");
  const { t } = useTranslation();
  const [fileError, setFileError] = useState("");
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  const handleFileSelection = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    const allowedFileTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
  
    if (selectedFile && allowedFileTypes.includes(selectedFile.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // setFile(reader.result);
      };
      reader.readAsDataURL(selectedFile);
      
      let _type = "";
      switch (selectedFile.type) {
        case "application/pdf":
          _type = "pdf";
          break;
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          _type = "doc";
          break;
        case "text/plain":
          _type = "txt";
          break;
        case "text/csv":
          _type = "csv";
          break;
        case "application/vnd.ms-excel":
          _type = "xls";
          break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          _type = "xlsx";
          break;
        default:
          _type = "doc";
          break;
      }
  
      setType(_type);
      setFileName(selectedFile.name);
      setSize((selectedFile.size / (1024 * 1024)).toFixed(2));
    } else {
      setFileError(
        t("Please select a valid document file (PDF, DOC, DOCX, TXT, CSV, XLS, XLSX, etc)")
      );
      event.target.value = null;
    }
  };
  
  // const handleFileSelection = (event) => {
  //   const selectedFile = event.target.files[0];
  //   setFile(selectedFile);
  //   const allowedFileTypes = [
  //     "application/pdf",
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     "text/plain",
  //     "text/csv",
  //     "application/vnd.ms-excel",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   ];

  //   if (selectedFile && allowedFileTypes.includes(selectedFile.type)) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       // setFile(reader.result);
  //     };
  //     reader.readAsDataURL(selectedFile);
  //     let _type = "doc";
  //     if (selectedFile.type === "application/pdf") {
  //       _type = "pdf";
  //     }
      
  //     setType(_type);
  //     setFileName(selectedFile.name);

  //     setSize((selectedFile.size / (1024 * 1024)).toFixed(2));
  //   } else {
  //     setFileError(
  //       t("Please select a valid document file (PDF, DOC, DOCX, TXT, CSV, XLS, XLSX, etc)")
  //     );
  //     event.target.value = null;
  //   }
  // };

  function calculateRemainingSize(maxFileSize, fileSize) {
    console.log(size);
    console.log("maxFileSize", maxFileSize);
    console.log("fileSize", fileSize);
    let remainingSize = fileSize - maxFileSize;
    console.log("remaining", remainingSize);
    console.log("size", size);
    if (size > remainingSize) {
      return true;
    } else {
      return false;
    }
  }

  const saveFile = async (e) => {
    e.preventDefault();
    let isValid = true;
    console.log("type",type)
    let remainingSize = calculateRemainingSize(maxFileSize, fileSize);
    console.log("res", remainingSize);
    const bot = id;

    if (!name) {
      setNameError(t("Title is required."));
      isValid = false;
    } else {
      setNameError("");
    }

    if (!file) {
      setFileError(t("File is required."));
      isValid = false;
    } else if (remainingSize === true) {
      setFileError(t("File size exceeds the total limit of plan"));
      isValid = false;
    } else {
      setFileError("");
    }

    if (isValid) {
      setLoading(true);
      let formData = new FormData();
      formData.append("file", file);
      formData.append("name", name);
      formData.append("fileName", fileName);
      formData.append("user", user);
      formData.append("type", type);
      formData.append("bot", bot);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      try {
        const responseData = await axios.post(
          `${API_URL}/upload`,
          formData,
          config
        );
        if (responseData) {
          setLoading(false);
          setMessage(t("File uploaded successfully."));
          setTypeMsg("Success");
          setShowAlert(true);
          props.doc();
          setName("");
          setFile(null);
          props.onHide();
          getAllDoc();
        }
      } catch (err) {
        console.log(err);
        setMessage(t("File not uploaded."));
        setTypeMsg("Danger");
        setShowAlert(true);
        setLoading(false);
      }
    }
  };

  const handleNameChange = (event) => {
    const newName = event.target.value;
    setName(newName);
    if (!newName) {
      setNameError(t("Title is required."));
    } else {
      setNameError("");
    }
  };

  function getAllDoc() {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/user_doc?id=${user}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoading(false);

        const docList = response.data.usersDoc;
        // Calculate total size in bytes
        const totalSizeBytes = docList.reduce((acc, doc) => acc + doc.size, 0);
        const totalSizeMegabytes = (totalSizeBytes / 1024).toFixed(2);

        setMaxFileSize(totalSizeMegabytes);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
  }

  useEffect(() => {
    getAllDoc();
  }, []);

  useEffect(() => {
    if (props.show) {
      setNameError("");
      setFileError("");
    }
  }, [props.show]);

  function checkPlan() {
    axios
      .get(`${API_URL}/${API_VERSION}/user/active-plan/${user}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.data) {
          setFileSize(response.data.plan.storage);
        }
      })
      .catch((error) => {
        return false;
      });
  }

  useEffect(() => {
    checkPlan();
  }, [user, API_URL, API_VERSION]);

  const { acceptedFiles } = useDropzone({
    accept: {
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "application/pdf": [".pdf"],
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    maxSize: maxFileSize,
    maxFiles: maxFileCount,
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <>
      <section className="client_main">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setTypeMsg("");
            setMessage("");
          }}
          alertClass={setTypeMsg}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("Add Document")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group mb-3">
              <label className="form-label">{t("Title")}</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                onChange={(event) => handleNameChange(event)}
              />
              <div className="text-danger">{nameError}</div>
            </div>
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="docFile">
                {t("Upload")}
              </label>
              <input
                type="file"
                className="form-control"
                id="docFile"
                accept=".pdf,.txt,.doc,.docx,.csv,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleFileSelection}
              />
              <div className="text-danger">{fileError}</div>
            </div>
            <div
              className="alert alert-primary d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-info-circle-filled"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#05204a"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
                  stroke-width="0"
                  fill="currentColor"
                />
              </svg>
              <div className="ms-2">
                {t(
                  "Please upload the pdf, txt, doc, docx, csv, xls, xlsx file only*"
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="submit"
              value="Save"
              className="button px-md-4 py-md-3"
              onClick={(e) => saveFile(e)}
            >
              {loading ? <BtnLoader /> : t("Save")}
            </button>
          </Modal.Footer>
        </Modal>
      </section>
    </>
  );
};

export default UserDocEdit;
